<span [ngSwitch]="expanded">
  <tix-icon svgIcon="chevron-down" *ngSwitchCase="true"> </tix-icon>
  <tix-icon svgIcon="chevron-up" *ngSwitchCase="false"> </tix-icon>
</span>
